import Cookie from "js-cookie";

const cookie = Cookie;

export default cookie;
